import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import InventoryRouteMiddleware from "./middleware/auth/inventoryValidRoute";

// ✅ Lazy load inventory pages
const AddStock = lazy(() => import("app/pages/Inventory/AddStock"));
const EditStock = lazy(() => import("app/pages/Inventory/EditStock"));
const InventoryList = lazy(() => import("app/pages/Inventory/List Inventory"));

export const rawMaterialRoute = [
  {
    middleware: [
      {
        element: InventoryRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory/rawmaterial",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={InventoryList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/inventory/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddStock} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/inventory/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={EditStock} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
